export default __webpack_public_path__ + "static/media/icn-contract.b65e5a41.svg";